import { render, staticRenderFns } from "./RegistroItem.vue?vue&type=template&id=50bc44fe&scoped=true"
import script from "./RegistroItem.vue?vue&type=script&lang=js"
export * from "./RegistroItem.vue?vue&type=script&lang=js"
import style0 from "./RegistroItem.vue?vue&type=style&index=0&id=50bc44fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bc44fe",
  null
  
)

export default component.exports